export type DownloadResourceType = 'Trail' | 'Recording' | 'Hike';

export interface DownloadResourceContext {
  id: string | null;
  graphqlType: DownloadResourceType;
  shareUrl: string;
  name: string;
  downloadPath: string | null;
}

declare global {
  interface Window {
    recordingId?: string | number;
    recordingName?: string;
    recordingShareUrl?: string;
    recordingDownloadPath?: string;
    trail_id?: string | number;
    trailId?: string | number;
    hike_id?: string | number;
    hikeName?: string;
    id?: string | number;
    trail_name?: string;
    trailName?: string;
    qrCodeUrl?: string;
    trail_share_url?: string;
    trail_download_path?: string;
  }
}

const RECORDING_TYPE: DownloadResourceType = 'Recording';
const TRAIL_TYPE: DownloadResourceType = 'Trail';
const HIKE_TYPE: DownloadResourceType = 'Hike';

function normaliseId(value: string | number | undefined): string | null {
  if (value === undefined || value === null || value === '') return null;
  return String(value);
}

export function getDownloadResourceContext(): DownloadResourceContext {
  const shareUrl =
    window.trail_share_url ||
    window.qrCodeUrl ||
    window.recordingShareUrl ||
    window.location.href;
  const name = window.trail_name || window.trailName || window.hikeName || window.recordingName || '';

  const recordingId = normaliseId(window.recordingId as string | number | undefined);
  if (recordingId) {
    return {
      id: recordingId,
      graphqlType: RECORDING_TYPE,
      shareUrl,
      name,
      downloadPath: window.recordingDownloadPath || window.location.pathname
    };
  }

  // Check for hike ID before trail ID
  const hikeId = normaliseId(window.hike_id as string | number | undefined);
  if (hikeId) {
    return {
      id: hikeId,
      graphqlType: HIKE_TYPE,
      shareUrl,
      name: window.hikeName || name,
      downloadPath: window.location.pathname
    };
  }

  const fallbackId = normaliseId(
    (window.trail_id as string | number | undefined) ??
    (window.trailId as string | number | undefined) ??
    (window.id as string | number | undefined)
  );

  return {
    id: fallbackId,
    graphqlType: TRAIL_TYPE,
    shareUrl,
    name,
    downloadPath: window.trail_download_path || window.location.pathname
  };
}

export function getResourceNoun(type: DownloadResourceType): 'recording' | 'trail' | 'hike' {
  if (type === RECORDING_TYPE) return 'recording';
  if (type === HIKE_TYPE) return 'hike';
  return 'trail';
}
